<template>
  <v-container>
    <v-stepper color="secondary accent-4" v-model="e1" >
        <v-stepper-header >
            <v-stepper-step color="secondary accent-4" :complete="e1 > 1" step="1">
                Informações pessoais
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="secondary accent-4" :complete="e1 > 2" step="2">
                Endereço
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="secondary accent-4" step="3">
                Contato
            </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
              <v-form v-model="validPessoais" ref="formPessoais">
                <v-row>
                    <v-col cols="12">
                        <v-card flat height="380px" style="overflow-y: auto;">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field color="secondary accent-4" v-model="usuario.nomeSocial" label="Nome Social" mask="A*"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field color="secondary accent-4" v-model="usuario.nomeCompleto" label="Nome Completo" mask="A*"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field color="secondary accent-4" v-model="usuario.nomeTratamento" label="Nome de Tratamento" mask="A*"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field color="secondary accent-4" v-model="usuario.dataNascimento" label="Data de Nascimento" prepend-icon="event" readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="secondary accent-4" v-model="usuario.dataNascimento" @input="menu = false" locale="pt-BR" no-title scrollable></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select color="secondary accent-4" v-model="usuario.genero" :items="generos" label="Gênero"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field color="secondary accent-4" v-model="usuario.cpf" label="CPF" v-mask="'###.###.###-##'" :rules="cpfRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field color="secondary accent-4" v-model="usuario.username" label="Nome de Usuário" mask="A*" :rules="usuarioRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field :rules="passwordRules" color="secondary accent-4" v-model="senha" name="login" label="Senha" :append-icon="value ? 'visibility' : 'visibility_off'" @click:append="() => (value1 = !value1)" :type="value1 ? 'password' : 'text'"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select color="secondary accent-4" v-model="usuario.perfil" :items="perfis" label="Perfil"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select color="secondary accent-4" v-model="usuario.idiomaPreferido" :items="idiomas" label="Idioma Preferido"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                      <v-text-field color="secondary accent-4" v-model="usuario.idExternoUser" :rules="idExternoUserRules" label="ID Usuário " mask="A*"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                      <v-text-field color="secondary accent-4" v-model="usuario.idExternoPrestador" :rules="idExternoPrestadorRules" label="ID Prestador" mask="A*"></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
              </v-form>
              <v-btn text @click="limparCampos(), cancelarOperacao()">
                    Cancelar
                </v-btn>
                <v-btn class="ml-2" :loading="load" color="secondary accent-4" @click="cadastrarInformacoesPessoais()">
                    Avançar
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="2">
                <v-form ref="formEndereco" v-model="validEndereco" >
                <v-row >
                  <v-col cols="12">
                    <v-card flat height="380px" style="overflow-y: auto; overflow-x: hidden;">
                      <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.logradouro" label="Logradouro"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.numero" label="Número"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.complemento" label="Complemento"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.bairro" label="Bairro"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.cidade" label="Cidade"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.estado" label="Estado"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field color="secondary accent-4" v-model="endereco.cep" label="CEP" mask="#####-###" ></v-text-field>
                      </v-col>
                    </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
                <v-btn text @click="e1=1" >
                    voltar
                </v-btn>
                <v-btn class="ml-2" :loading="load" color="secondary accent-4" @click="cadastrarEndereco()">
                    Avançar
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
                <v-form ref="formContato" v-model="validContato">
                  <v-row>
                    <v-col cols="12">
                      <v-card flat height="380px" style="overflow-y: auto; overflow-x: hidden;">
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="contato.telefone"
                              label="Telefone"
                              v-mask="'(##) ####-####'"
                              color="secondary accent-4"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="contato.celular"
                              label="Celular"
                              v-mask="'(##) #####-####'"
                              color="secondary accent-4"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="contato.email"
                              label="Email"
                              color="secondary accent-4"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
                <v-btn @click="e1 = 2">
                    Voltar
                </v-btn>
                <v-btn class="ml-2" color="secondary accent-4" @click="cadastrarContato()">
                    Concluir
                </v-btn>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" persistent width="400px">

      <v-card>
        <v-card-title>
          Sucesso
        </v-card-title>

        <v-card-text v-if="cadastro == true">
          Cadastro realizado com sucesso!
        </v-card-text>
        <v-card-text v-else>
          Edição realizada com sucesso!
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn v-if="cadastro" text @click="dialog = false, $router.push('/usuarios')">OK</v-btn>
          <v-btn v-else text @click="dialog = false, $router.push({name: 'perfilUsuario', params: {_id: _id }})">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import usuarioService from '../../../services/usuario.service'
import {
  mask
} from 'vue-the-mask'
var sha1 = require('sha1')
export default {
  directives: {
    mask
  },
  props: {
    cadastro: {
      type: Boolean
    },
    _id: {
      type: String
    }
  },
  data () {
    return {
      e1: 1,
      senha: '',
      usuario: {
        nomeSocial: '',
        nomeCompleto: '',
        nomeTratamento: '',
        dataNascimento: '',
        genero: '',
        cpf: '',
        username: '',
        perfil: '',
        idiomaPreferido: '',
        idExternoUser: '',
        idExternoPrestador: ''
      },
      contato: {
        telefone: '',
        celular: '',
        email: ''
      },
      endereco: {
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: ''
      },
      menu: false,
      generos: ['Masculino', 'Feminino', 'Outro'],
      perfis: ['nutricionista'],
      idiomas: ['Português', 'Inglês', 'Espanhol', 'Outro'],
      showPassword: false,
      passwordRules: [
        value => (this.cadastro ? !!value || 'A senha é obrigatória' : true)
      ],
      cpfRules: [v => !!v || 'CPF é obrigatório'],
      usuarioRules: [v => !!v || 'Usuário é obrigatório'],
      idExternoUserRules: [v => !!v || 'ID Usuário é obrigatório'],
      idExternoPrestadorRules: [v => !!v || 'ID Prestador é obrigatório'],
      value1: 'password',
      validPessoais: false,
      validEndereco: false,
      validContato: false,
      load: false,
      value: '',
      dialog: false
    }
  },
  methods: {
    cadastrarInformacoesPessoais () {
      var cpfAux = this.usuario.cpf.replace(/[.-]/g, '')
      if (this.$refs.formPessoais.validate()) {
        this.load = true
        var userAux = {}
        if (!this.cadastro) {
          userAux = {
            _id: this._id,
            nomeSocial: this.usuario.nomeSocial,
            nomeCompleto: this.usuario.nomeCompleto,
            nomeTratamento: this.usuario.nomeTratamento,
            dataNascimento: this.usuario.dataNascimento,
            genero: this.usuario.genero,
            cpf: cpfAux,
            username: this.usuario.username,
            senha: this.senha != '' ? sha1(this.senha) : '',
            perfil: this.usuario.perfil,
            idiomaPreferido: this.usuario.idiomaPreferido,
            idExternoUser: this.usuario.idExternoUser,
            idExternoPrestador: this.usuario.idExternoPrestador
          }
          console.log('EDITAR USUARIO: ', userAux)
        } else {
          userAux = this.usuario
          userAux.cpf = cpfAux
          userAux.senha = sha1(this.senha)
          console.log('CADASTRAR USUARIO: ', userAux)
        }

        usuarioService.cadastrarUsuario({
          usuario: userAux
        }).then(r => {
          if (r.status == 200) {
            console.log('RESPOSTA: ', r.data)
            this.usuario._id = r.data._id
          }
        }).finally(() => {
          this.load = false
          this.e1 = 2
        })
      }
    },
    cadastrarEndereco () {
      if (this.$refs.formEndereco.validate()) {
        this.load = true
        var userAux = {}
        if (!this.cadastro) {
          userAux = {
            usuario: {
              _id: this.usuario._id
            },
            endereco: {
              logradouro: this.endereco.logradouro,
              numero: this.endereco.numero,
              complemento: this.endereco.complemento,
              bairro: this.endereco.bairro,
              cidade: this.endereco.cidade,
              estado: this.endereco.estado,
              cep: this.endereco.cep,
              _id: this.endereco._id
            }
          }
          console.log('EDITAR ENDERECO: ', userAux)
        } else {
          userAux = {
            usuario: {
              _id: this.usuario._id
            },
            endereco: {
              logradouro: this.endereco.logradouro,
              numero: this.endereco.numero,
              complemento: this.endereco.complemento,
              bairro: this.endereco.bairro,
              cidade: this.endereco.cidade,
              estado: this.endereco.estado,
              cep: this.endereco.cep
            }
          } 
          console.log('CADASTRAR ENDERECO: ', userAux)
        }

        usuarioService.cadastrarUsuario({
          usuario: userAux.usuario,
          endereco: userAux.endereco
        }).then(r => {
          if (r.status == 200) {
            console.log('RESPOSTA ENDERECO: ', r.data)
          }
        }).finally(() => {
          this.load = false
          this.e1 = 3
        })
      }
    },
    cadastrarContato () {
      if (this.$refs.formContato.validate()) {
        this.load = true
        var userAux = {}
        if (!this.cadastro) {
          userAux = {
            usuario: {
              _id: this.usuario._id
            },
            contato: {
              telefone: this.contato.telefone,
              celular: this.contato.celular,
              email: this.contato.email,
              _id: this.contato._id
            }

          }
          console.log('EDITAR CONTATO: ', userAux)
        } else {
          userAux = {
            usuario: {
              _id: this.usuario._id
            },
            contato: {
              telefone: this.contato.telefone,
              celular: this.contato.celular,
              email: this.contato.email
            }
          } 
          console.log('CADASTRAR CONTATO: ', userAux)
        }
        usuarioService.cadastrarUsuario({
          usuario: userAux.usuario,
          contato: userAux.contato
        }).then(r => {
          if (r.status == 200) {
            console.log('RESPOSTA CONTATO: ', r.data)
          }
        }).finally(() => {
          this.load = false
          this.dialog = true
          this.limparCampos()
        })
      }
    },
    limparCampos () {
      this.usuario._id = ''
      this.usuario.nomeSocial = ''
      this.usuario.nomeCompleto = ''
      this.usuario.nomeTratamento = ''
      this.usuario.dataNascimento = ''
      this.usuario.genero = ''
      this.usuario.cpf = ''
      this.usuario.username = ''
      this.senha = ''
      this.usuario.perfil = ''
      this.usuario.idiomaPreferido = ''

      this.endereco.logradouro = ''
      this.endereco.numero = ''
      this.endereco.complemento = ''
      this.endereco.bairro = ''
      this.endereco.cidade = ''
      this.endereco.estado = ''
      this.endereco.cep = ''

      this.contato.telefone = ''
      this.contato.celular = ''
      this.contato.email = ''
    },
    buscarUsuario () {
      console.log(this._id)
      usuarioService.buscarUsuario(this._id).then(r => {
        if (r.status == 200) {
          console.log('resp: ', r.data)
          this.usuario = r.data
          this.endereco = r.data.endereco
          this.contato = r.data.contato
        }
      })
    },
    cancelarOperacao () {
      this.cadastro ? this.$router.push({ name: 'usuarios' }) : this.$router.push({ name: 'perfilUsuario', params: { _id: this._id } })
    }
  },
  mounted () {
  },
  created () {
    if (this._id != null && !this.cadastro) {
      this.buscarUsuario()
    }
  }
}
</script>
